// extracted by mini-css-extract-plugin
export default {"container":"alert_container__si08H","box":"alert_box__clQdL","infoContainer":"alert_infoContainer__6j2s7","close":"alert_close__P9720"};